"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Activity, ArrowRight, Play } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SeeTheEngineInAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="see-the-engine-in-action" className="dark relative flex min-h-[85vh] w-full items-center justify-center overflow-hidden bg-background text-foreground py-24">
      {}
      <div className="absolute inset-0 z-0 bg-black">
        <video autoPlay loop muted playsInline className="h-full w-full object-cover opacity-20 mix-blend-screen" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586938/img/mint_blue_tech_data_viz.png">
          {}
          <source src="https://cdn.pixabay.com/video/2020/05/25/40131-424917415_large.mp4" type="video/mp4" />
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586938/img/mint_blue_tech_data_viz.png" alt="Data Visualization Background" className="h-full w-full object-cover opacity-20" />
        </video>
        
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-background/90 via-background/40 to-background/90" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,var(--background)_100%)] opacity-80" />
      </div>

      {}
      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div ref={ref} className={`mx-auto flex max-w-4xl flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          {}
          <div className="mb-8 inline-flex items-center gap-2 border border-primary/30 bg-primary/10 px-4 py-2 text-sm font-medium tracking-wider text-primary uppercase backdrop-blur-sm">
            <Activity className="size-4 animate-pulse" />
            <span>Live System Demonstration</span>
          </div>

          {}
          <h1 className="mb-6 text-5xl font-extrabold tracking-tighter sm:text-6xl md:text-7xl lg:text-8xl">
            Witness the <br className="hidden sm:block" />
            <span className="bg-gradient-to-r from-primary to-chart-4 bg-clip-text text-transparent">
              Cutting Edge
            </span>
          </h1>

          {}
          <p className="mb-10 max-w-2xl text-lg leading-relaxed text-muted-foreground sm:text-xl md:text-2xl">
            Experience the raw power of our dual-model lead generation engine. 
            Unlock scalable, high-converting opportunities tailored specifically for your home improvement business growth.
          </p>

          {}
          <div className="flex w-full flex-col items-center justify-center gap-4 sm:w-auto sm:flex-row">
            <Button asChild size="lg" className="group h-14 w-full bg-gradient-to-r from-primary to-chart-4 px-8 text-base hover:opacity-90 sm:w-auto">
              <Link to="/ReserveYourDemoPage">
                <Play className="mr-2 size-5 fill-current" />
                Book Your Demo
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="group h-14 w-full border-border/50 bg-background/20 px-8 text-base backdrop-blur-md hover:bg-accent/50 sm:w-auto">
              <Link to="/OurExpertisePage">
                Explore the Tech
                <ArrowRight className="ml-2 size-5 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>

          {}
          <div className="mt-16 grid grid-cols-2 gap-8 border-t border-border/30 pt-8 text-sm text-muted-foreground sm:grid-cols-4">
            <div className="flex flex-col items-center gap-1">
              <span className="font-mono text-xl font-bold text-foreground">Real-Time</span>
              <span>Data Processing</span>
            </div>
            <div className="flex flex-col items-center gap-1">
              <span className="font-mono text-xl font-bold text-foreground">Exclusive</span>
              <span>Lead Routing</span>
            </div>
            <div className="flex flex-col items-center gap-1">
              <span className="font-mono text-xl font-bold text-foreground">Scalable</span>
              <span>Infrastructure</span>
            </div>
            <div className="flex flex-col items-center gap-1">
              <span className="font-mono text-xl font-bold text-foreground">Verified</span>
              <span>Intent Signals</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}